import React, { useState } from 'react';
const callbackHandler = (callback, defaultCallback, value) => {
    if (callback) {
        if ('mode' in callback) {
            if (callback.mode === 'compose') {
                return (e) => {
                    defaultCallback(e);
                    callback.cb(e);
                };
            }
            if (callback.mode === 'pipe') {
                return (e) => defaultCallback(callback.cb(e));
            }
        }
        else {
            if (!value) {
                return (e) => {
                    defaultCallback(e);
                    callback(e);
                };
            }
            return callback;
        }
    }
    return defaultCallback;
};
const methods = {
    onBlur: ({ errorSetter }) => () => {
        errorSetter(true);
    },
    onChange: ({ valueSetter, errorSetter }) => (e) => {
        const target = e === null || e === void 0 ? void 0 : e.target;
        valueSetter(target.value);
        errorSetter(false);
    },
    onClear: ({ valueSetter }) => () => {
        valueSetter('');
    },
};
function stateManager(Component) {
    const PureComponent = Component;
    return ({ defaultValue, value, errorMessage, showErrorOnMount = true, ...commonProps }) => {
        var _a;
        const [internalValue, setInternalValue] = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : '');
        const [showError, setShowError] = useState(showErrorOnMount);
        const handlers = Object.keys(methods).reduce((acc, method) => {
            return {
                ...acc,
                [method]: callbackHandler(commonProps[method], methods[method]({
                    valueSetter: setInternalValue,
                    errorSetter: setShowError,
                }), value),
            };
        }, {});
        const props = {
            ...commonProps,
            ...handlers,
            value: (_a = value !== null && value !== void 0 ? value : internalValue) !== null && _a !== void 0 ? _a : '',
            errorMessage: showError ? errorMessage : undefined,
        };
        return React.createElement(PureComponent, { ...props });
    };
}
export default stateManager;
//# sourceMappingURL=index.js.map